"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.constantRoutes = exports.asyncRoutes = void 0;
exports.resetRouter = resetRouter;
var _vue = _interopRequireDefault(require("vue"));
var _vueRouter = _interopRequireDefault(require("vue-router"));
var _layout = _interopRequireDefault(require("@/layout"));
var _store = _interopRequireDefault(require("./modules/store"));
var _order = _interopRequireDefault(require("./modules/order"));
var _user = _interopRequireDefault(require("./modules/user"));
var _distribution = _interopRequireDefault(require("./modules/distribution"));
var _marketing = _interopRequireDefault(require("./modules/marketing"));
var _integral = _interopRequireDefault(require("./modules/integral"));
var _financial = _interopRequireDefault(require("./modules/financial"));
var _content = _interopRequireDefault(require("./modules/content"));
var _operation = _interopRequireDefault(require("./modules/operation"));
var _appSetting = _interopRequireDefault(require("./modules/appSetting"));
var _maintain = _interopRequireDefault(require("./modules/maintain"));
var _mobile = _interopRequireDefault(require("./modules/mobile"));
var _statistic = _interopRequireDefault(require("./modules/statistic"));
var _business = _interopRequireDefault(require("./modules/business"));
var _applet = _interopRequireDefault(require("./modules/applet"));
var _mealOrder = _interopRequireDefault(require("./modules/mealOrder"));
var _offStore = _interopRequireDefault(require("./modules/offStore"));
var _offsetHome = _interopRequireDefault(require("./modules/offsetHome"));
var _welfare = _interopRequireDefault(require("./modules/welfare"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _data = _interopRequireDefault(require("./modules/data"));
var _sjt = _interopRequireDefault(require("./modules/sjt"));
var _raffle = _interopRequireDefault(require("./modules/raffle"));
var _dental = _interopRequireDefault(require("./modules/dental"));
var _rsManagement = _interopRequireDefault(require("./modules/rsManagement"));
var _invoice = _interopRequireDefault(require("./modules/invoice"));
var _rs = _interopRequireDefault(require("./modules/rs"));
var _jdStore = _interopRequireDefault(require("./modules/jdStore"));
var _samStore = _interopRequireDefault(require("./modules/samStore"));
var _orderViewConfig = _interopRequireDefault(require("./modules/orderViewConfig"));
var _merchantReconciliation = _interopRequireDefault(require("./modules/merchantReconciliation"));
var _instantDiscount = _interopRequireDefault(require("./modules/instantDiscount"));
var _wechatOpenPlatform = _interopRequireDefault(require("./modules/wechatOpenPlatform"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
_vue.default.use(_vueRouter.default);

/* Layout */

/* Router Modules */
// import componentsRouter from './modules/components'

// 积分（独立，不在 marketing 下）

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                legacy flag; does not disable tab caching (edit forms keep drafts)
    tabCache: false              disable tab caching for live pages with external resources
    cacheDisposable: true        reloadable page; only the 8 most recently used such tabs stay cached
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 *
 */
function getDefaultPath() {
  var JavaInfo;
  if (_jsCookie.default.get('JavaInfo')) {
    JavaInfo = JSON.parse(_jsCookie.default.get('JavaInfo'));
    console.log(JavaInfo, 'JavaInfo');
  } else {
    JavaInfo = {
      isoffine: false
    };
  }

  // 这里可以根据业务逻辑动态返回路径
  return JavaInfo.isoffine ? '/offsetHome' : '/dashboard'; // 例如返回 '/dynamic-dashboard'
}
var constantRoutes = exports.constantRoutes = [
// 商品
_store.default,
// 订单
_order.default,
// 会员
_user.default,
// 分销
_distribution.default,
// 营销
_marketing.default,
// 积分（独立，不在 marketing 下）
_integral.default,
// 财务
_financial.default,
// 内容
_content.default,
// 设置
_operation.default,
// 应用
_appSetting.default,
// 维护
_maintain.default,
//移动端管理
_mobile.default,
// 统计管理
_statistic.default,
//企业管理
_business.default,
// 小程序管理
_applet.default, _wechatOpenPlatform.default, _mealOrder.default,
//核销首页
_offsetHome.default,
// 核销列表
_offStore.default,
//三甲通
_sjt.default,
// 福卡管理
_welfare.default,
// 统计
_data.default,
//抽奖
_raffle.default,
// 华西口腔管理
_dental.default,
// RS管理
_rs.default,
// 仁寿相关管理
_rsManagement.default,
// 京东管理
_jdStore.default,
// 山姆管理
_samStore.default,
// 订单查看配置
_orderViewConfig.default,
// 商家对账
_merchantReconciliation.default,
// 立减活动管理
_instantDiscount.default,
//财务相关
_invoice.default, {
  path: '/404',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/views/error-page/404'));
    });
  },
  hidden: true
}, {
  path: '/redirect',
  component: _layout.default,
  hidden: true,
  children: [{
    path: '/redirect/:path(.*)',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/redirect/index'));
      });
    }
  }]
}, {
  path: '/auth-send',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/views/mobile/auth-send'));
    });
  },
  hidden: true
}, {
  path: '/login',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/views/login/index'));
    });
  },
  hidden: true
}, {
  path: '/auth-redirect',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/views/login/auth-redirect'));
    });
  },
  hidden: true
}, {
  path: '/401',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/views/error-page/401'));
    });
  },
  hidden: true
}, {
  path: '/',
  component: _layout.default,
  redirect: getDefaultPath(),
  children: [{
    path: 'dashboard',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/dashboard/index'));
      });
    },
    name: 'Dashboard',
    meta: {
      title: '主页',
      icon: 'dashboard',
      affix: true
    }
  }, {
    path: 'product',
    name: "product",
    meta: {
      title: '商品统计'
    },
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/statistic/product/index'));
      });
    }
  }, {
    path: 'statuser',
    name: "statuser",
    meta: {
      title: '用户统计'
    },
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/statistic/user/index'));
      });
    }
  }, {
    path: 'transaction',
    name: "transaction",
    meta: {
      title: '交易统计'
    },
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/statistic/transaction/index'));
      });
    }
  }]
}, {
  path: '/setting/uploadPicture',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/components/uploadPicture/index.vue'));
    });
  },
  name: 'uploadPicture'
},
// 404 page must be placed at the end !!!
{
  path: '*',
  redirect: '/404',
  hidden: true
}];

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
var asyncRoutes = exports.asyncRoutes = [];
var createRouter = function createRouter() {
  return new _vueRouter.default({
    // mode: 'history', // require service support
    mode: 'history',
    scrollBehavior: function scrollBehavior() {
      return {
        y: 0
      };
    },
    routes: constantRoutes
  });
};
var router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}
var _default = exports.default = router;